module.exports = __webpack_public_path__ + "img/img-8.10aeb795.png";